import { getRandom4, ResGetRandom4 } from '@/service/tour/main/getRandom4';
import { useQuery } from '@tanstack/react-query';
import { RQMainKey } from './RQMainKey';

export const useRandom4Query = () => {
  return useQuery<ResGetRandom4, Error, ResGetRandom4['result']>({
    queryKey: RQMainKey.random4,
    queryFn: getRandom4,
    select: (data) => data.result,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
  });
};
